import { render } from "./BaseLayout.vue?vue&type=template&id=a89aeec6&scoped=true"
import script from "./BaseLayout.vue?vue&type=script&lang=js"
export * from "./BaseLayout.vue?vue&type=script&lang=js"

import "./BaseLayout.vue?vue&type=style&index=0&id=a89aeec6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a89aeec6"]])

export default __exports__